export const PAUSE_CONFIRMED = "PAUSE_CONFIRMED";
export const CURRENT_CONFIRMED = "CURRENT_CONFIRMED";
export const TOMORROW_PAUSE = "TOMORROW_PAUSE";
export const TOMORROW = "TOMORROW";
export const CURRENT_PAUSE = "CURRENT_PAUSE";
export const PAUSE = "PAUSE";
export const MISSED = "MISSED";
export const CHEATED = "CHEATED";
export const SUSPICIOUS = "SUSPICIOUS";
export const CONFIRMED = "CONFIRMED";
export const PENDING = "PENDING";
export const CURRENT_PENDING = "CURRENT_PENDING";



// WEBPACK FOOTER //
// ./src/overview/DayStates.js